import * as React from "react";
import { forwardRef } from "react";
const SvgClock = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", className: "lucide lucide-clock-icon lucide-clock", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M12 6v6l4 2" }), /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 12, r: 10 }));
const ForwardRef = forwardRef(SvgClock);
export default ForwardRef;
